

@if (uploader?.queue?.length==0) {
  <div class="file-input-container" style="text-align: center;">
    <label style="    background-color: #f04e4c;" >
      <!-- <input type="file" ng2FileSelect [uploader]="uploader"  /> -->
      <!-- <input type="file" ng2FileSelect
      id="file-upload"
      [uploader]="uploader"
      /> -->
      <!-- <input type='file' ng2FileSelect id="sImage"[uploader]="uploader" name="sImage" accept="image/*" capture="environment"> -->
      <input type="file"
        ng2FileSelect
        accept="image/*"
        [uploader]="uploader"
        >
        Select profile Pic
      </label>
    </div>
  }

  <span style="font-size: 20px;font-weight: bold;">Image: {{ uploader?.queue?.length }}</span>

  <ion-list>
    <ion-reorder-group (ionItemReorder)="reorderFiles($event)" disabled="false">
      @for (item of uploader.queue; track item) {
        <ion-item>
          <ion-label>
            {{ item?.file?.name }}
          </ion-label>
          <ion-label>
            {{ item?.file?.size/1024/1024 | number:'.2' }} MB
          </ion-label>
          <button type="button" class="btn btn-danger btn-xs" (click)="item.remove()">
            <span class="glyphicon glyphicon-trash"></span>
            Remove
          </button>
        </ion-item>
      }
    </ion-reorder-group>
  </ion-list>